import { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import {
  Box,
  Button,
  Center,
  Column,
  Ribbon,
  Typography,
} from '@tempmee/react';
import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { BackButton, Icon } from '../../commonComponents';
import ConfirmPopup from '../shared/ConfirmPopup';
import { CollapsibleCardsGroup } from './components/CollapsibleCardsGroup/CollapsibleCardsGroup';
import { useAccountInformation } from './hooks/useAccountInformation/useAccountInformation';

export const AccountInformation = () => {
  const {
    methods,
    onSubmit,
    isLoading,
    isButtonDisabled,
    isValid,
    hasWarning,
    confirmationExitModalOpen,
    setConfirmationExitModalOpen,
    navigateToPending,
    clearPendingNavigation,
  } = useAccountInformation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Column className="component_container" style={{ justifyContent: 'flex-start' }}>
        <Column className="floating_container" style={{ paddingBottom: 50, width: 'auto' }}>
          {/* Page header */}
          <Box style={{ position: 'relative', marginBottom: 32, marginTop: 60 }}>
            <Center>
              <Box style={{ position: 'absolute', left: 20 }}>
                <BackButton />
              </Box>
              <Typography size="heading_2" bold textAlign="center">
                Account Information
              </Typography>
            </Center>
          </Box>

          {/* Main content area */}
          <Box
            style={{
              backgroundColor: colors.neutral['50'],
              flex: 1,
              marginLeft: 60,
              marginRight: 60,
              paddingBottom: 80,
              paddingLeft: 100,
              paddingRight: 100,
              paddingTop: 32,
              width: 'auto',
            }}
          >
            {(!isValid || hasWarning) && (
              <Box style={{ marginBottom: -8 }}>
                <Ribbon variant="soft-warning" Icon={OutlineWarning01Icon}>
                  Missing information: Complete missing fields for higher chances of filling shifts.
                </Ribbon>
              </Box>
            )}

            <FormProvider {...methods}>
              <CollapsibleCardsGroup />

              <Center style={{ marginTop: 60 }}>
                <Button
                  disabled={isButtonDisabled}
                  size="md"
                  onClick={onSubmit}
                  isLoading={isLoading}
                >
                  Save
                </Button>
              </Center>
            </FormProvider>
          </Box>
        </Column>
      </Column>

      {/* DS ConfirmationModal truncates "Leave Anyway" — Button sm uses fixed w-[140px] */}
      {confirmationExitModalOpen && (
        <ConfirmPopup
          Icon={() => <Icon name="warning-outline" size={80} />}
          leftButtonAction={() => {
            clearPendingNavigation();
            setConfirmationExitModalOpen(false);
          }}
          leftButtonText="Go Back"
          rightButtonAction={navigateToPending}
          rightButtonText="Leave Anyway"
          title="Are You Sure You Want to Leave?"
          titleStyle={{ marginBottom: 20, marginTop: 20 }}
          descriptionStyle={{ marginBottom: 40 }}
          description="Updates made to your account information haven't been saved. Do you still want to leave?"
        />
      )}
    </>
  );
};
